import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap5/Form';

import {
  ErrorMessage,
  useField,
} from 'formik';

export default function HorizontalSelectRadioField(props) {
  const {
    name, label, collection, hint, required, disabled, onClick,
    wrapperClassName, containerClassName, containerStyle, optionClassName,
  } = props;

  const [, meta, helpers] = useField(props);
  const { value } = meta;
  const { setValue } = helpers;

  const onItemClick = (val, e) => {
    if (value !== val) {
      setValue(val);

      if (onClick !== undefined) {
        onClick(val, e);
      }
    }
  };

  return (
    <Form.Group className={wrapperClassName} controlId="formBasicEmail">
      {label && (
        <Form.Label>
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
      )}

      <div className={containerClassName} style={containerStyle}>
        {collection.map((item) => (
          <Form.Check
            key={item.value}
            type="radio"
            name={name}
            id={`${name}-${item.value}`}
            label={item.label}
            className={optionClassName}
            defaultChecked={value !== undefined && value === item.value}
            disabled={item.disable || disabled}
            onClick={(e) => onItemClick(item.value, e)}
          />
        ))}
      </div>

      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}

      <ErrorMessage
        name={name}
        render={(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
      />
    </Form.Group>
  );
}

HorizontalSelectRadioField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  collection: PropTypes.arrayOf(PropTypes.object).isRequired,
  hint: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  wrapperClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  containerStyle: PropTypes.object,
  optionClassName: PropTypes.string,
};

HorizontalSelectRadioField.defaultProps = {
  hint: '',
  required: false,
  disabled: false,
  onClick: () => {},
  wrapperClassName: 'mb-3',
  containerClassName: 'text-center',
  containerStyle: {},
  optionClassName: '',
};
